import { render, staticRenderFns } from "./AboutProjectMembers.vue?vue&type=template&id=02638fd9"
import script from "./AboutProjectMembers.vue?vue&type=script&lang=ts"
export * from "./AboutProjectMembers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports